import React from 'react'
import PropTypes from 'prop-types'

import { MEDIA_PREFERENCE, PROGRAMMING_FILTER } from '../../../constants/commons';
import TopicHelpers from '../../../classes/TopicHelpers'
import TopicPlanFilterHelpers from '../../../classes/TopicPlanFilterHelpers'

class ProgrammingFilterComponent extends React.Component {
  static propTypes = {
    setFilters: PropTypes.func.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    module: PropTypes.string.isRequired
  }

  render () {
    return (
      <>
        <ul className="checkList">
          <li><h4>Programming Filters (AND)</h4></li>
          {this.li('Primetime', 'Primetime')}
          {this.li('Broadcast', 'Broadcast')}
          {this.li('Cable', 'Cable')}
          {this.li('Premium', 'Premium')}
          {this.li('BroadcastPrimetime', 'Broadcast Primetime')}
          {this.li('RemoveCancelled', 'Remove Cancelled')}
          {this.li('RemoveSpecial', 'Remove Special')}
        </ul>
      </>
    )
  }

  li = (filter, text) => {
    let pgmFilter = TopicPlanFilterHelpers.programmingFilter(filter)
    let currentValue = this.props.programmingFilters && this.props.programmingFilters.find(f => TopicHelpers.equals(f, pgmFilter))
    const value = currentValue ? true : false
    return (
      <li>
        <input
          type="checkbox" id={`${text}`}
          checked={value}
          onChange={this.applyQuickFilter.bind(this, filter)} />
        <span></span>
        <label htmlFor={`${text}`}>{text}</label>
      </li>
    )
  }

  /** Apply one of the quickfilters and update the table filtering */
  applyQuickFilter = (filter) => {
    let filters = null

    if (filter !== 'None') {
      filters = TopicPlanFilterHelpers.programmingFilter(filter)
    }

    this.props.setFilters(filters, PROGRAMMING_FILTER, MEDIA_PREFERENCE)
  }
}

export default ProgrammingFilterComponent